import React from "react";
import PharmacyTabs from "./PharmacyTabs";

function PharmacyComponent() {
  return (
    <>
      <div className="flex flex-col gap-3 h-[94%]">
        <div className="h-full">
          <PharmacyTabs />
        </div>
      </div>
    </>  
  );
}

export default PharmacyComponent;
